import React from "react";
import styled from "styled-components";

import { Button } from "./Buttons";
import { Modal } from "./Modal";
import { Body2, H3 } from "./Headings";
import FlexBox from "./FlexBox";

const Container = styled(FlexBox)`
  width: 100%;
  padding: 1.5rem;
  flex-direction: column;
  row-gap: 1.5rem;
`;

const Content = styled(FlexBox)`
  flex-direction: column;
  row-gap: 1.5rem;

  @media screen and (max-width: 768px) {
    row-gap: 1rem;
  }
`;

const Footer = styled(FlexBox)`
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    row-gap: 0.75rem;

    button {
      width: 100%;
    }

    button[outline],
    button:first-child {
      border-color: transparent;
      background-color: transparent;
    }
  }
`;

const ConfirmationPopup = ({
  title,
  subtitle,
  onCancel,
  onConfirm,
  cancelTitle,
  confirmTitle,
  children,
  showConfirmAsDanger = false,
  isSubmitBtnDisabled,
}) => {
  return (
    <Modal
      XS
      width="27rem"
      mobileWidth="calc(100% - 2rem)"
      height="auto"
      mobileHeight="fit-content"
      borderRadius="1rem"
      mobileBorderRadius="1rem"
      boxShadow
    >
      <Container>
        <Content>
          {title && <H3 bold>{title}</H3>}
          {subtitle && <Body2>{subtitle}</Body2>}
          {children}
        </Content>
        <Footer>
          <Button outline tertiary onClick={onCancel}>
            {cancelTitle}
          </Button>
          <Button
            danger={showConfirmAsDanger}
            onClick={onConfirm}
            disabled={isSubmitBtnDisabled}
          >
            {confirmTitle}
          </Button>
        </Footer>
      </Container>
    </Modal>
  );
};

export default ConfirmationPopup;
